export const ORDER_TYPE = {
  BOTH_SNP: 'BothSNP',
  SUBSCRIPTION: 'Subscription',
  PACKAGE: 'Package',
  REPORT: 'Report',
}
